import { Modal } from "antd"
import { useIssueInvoice } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"

export const useIssueInvoiceModal = (
  invoiceUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const issueMutation = useIssueInvoice(invoiceUuid)

  const showIssueInvoiceModal = (): void => {
    modal.confirm({
      title: "Issue Invoice",
      content:
        "Are you sure you want to issue this invoice? Once issued, it will be sent to the member and cannot be edited.",
      okText: "Issue Invoice",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          issueMutation.mutate(undefined, {
            onSuccess: () => {
              message.success("Invoice issued successfully")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to issue invoice: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showIssueInvoiceModal,
  }
}
